"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var TextareaWrapper = /** @class */ (function (_super) {
    __extends(TextareaWrapper, _super);
    function TextareaWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextareaWrapper.prototype.findNativeTextarea = function () {
        return this.find('.awsui-textarea');
    };
    /**
     * Sets the value of the component.
     *
     * This does not fire a change event, you need to call `fireChangeEvent` if you rely on change events.
     *
     * @param value value to set the text area to.
     */
    TextareaWrapper.prototype.setTextareaValue = function (value) {
        var element = this.findNativeTextarea().getElement();
        element.value = value;
        this.findNativeTextarea().fireEvent(new dom_1.InputEvent('input'));
    };
    TextareaWrapper.prototype.fireChangeEvent = function () {
        this.findNativeTextarea().fireEvent(new dom_1.InputEvent('change'));
    };
    __decorate([
        dom_1.usesDom
    ], TextareaWrapper.prototype, "setTextareaValue", null);
    __decorate([
        dom_1.usesDom
    ], TextareaWrapper.prototype, "fireChangeEvent", null);
    return TextareaWrapper;
}(dom_1.ComponentWrapper));
exports.default = TextareaWrapper;
//# sourceMappingURL=awsui-textarea.js.map